module.exports = __webpack_public_path__ + "600fcc52f5f829eeb488da6fb90edf07.jpg";